import type { MarketComponentMarketComponentIO } from "../../generated/fresh-guard-api";

const parseStringToIntWithDefaultValue = (
  value: string | undefined | null,
  standard: number,
) => {
  if (value !== undefined && value !== null) {
    const convertedValue = parseInt(value);
    if (!isNaN(convertedValue)) {
      return convertedValue;
    }
  }

  return standard;
};

const parseNextNumber = (
  marketComponents: MarketComponentMarketComponentIO[],
  marketComponent: MarketComponentMarketComponentIO,
) => {
  const number = marketComponents[marketComponents.length - 1]?.number;

  return typeof number === "number" ? number + 1 : marketComponent.number;
};

export { parseStringToIntWithDefaultValue, parseNextNumber };
